module.exports = {
      id: "read-more-arrow-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#read-more-arrow",
      toString: function () {
        return this.url;
      }
    }